module.exports = __webpack_public_path__ + "img/close.a1f516ab.svg";